import React, { useState } from 'react';
import { Button } from '@mui/material';

import SigDetailDialog from './SigDetailDialog';

/**
 * Add New, which opens the same dialog that manages an existing sig.
 *
 * It used to open a form of its own that offered directions and nothing else, so a new sig's
 * catalog approvals could only be added by saving it, finding it in the list again and opening the
 * manage dialog. The create mutation has always accepted both, so the second trip was the form's
 * limitation rather than the server's.
 */
const AddSigButton = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Button
        sx={{ height: 33, mr: 2 }}
        variant='contained'
        color='primary'
        onClick={() => setIsDialogOpen(true)}
      >
        Add New
      </Button>

      {isDialogOpen && <SigDetailDialog isCreating onClose={() => setIsDialogOpen(false)} />}
    </>
  );
};

export default AddSigButton;
